import { render, staticRenderFns } from "./NovaUnimed.vue?vue&type=template&id=2b55ca62"
import script from "./NovaUnimed.vue?vue&type=script&lang=js"
export * from "./NovaUnimed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports